import {
  Step,
  StepButton,
  StepLabel,
  Stepper,
  styled,
  Typography,
} from "@material-ui/core";

import { lang } from "../../../i18nLang";

const CaptionLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.7rem",
  display: "block",
  color: theme.palette.grey[500],
}));

export type TStepTitle = {
  title: string;
  optional?: boolean;
  valid?: boolean;
  complete?: boolean;
};

interface IProps {
  steps: TStepTitle[];
  activeStep: number;
  stepsClickable?: boolean;
  onClickStep?: (index: number) => void;
}

const TabsStepper = ({
  steps,
  activeStep,
  stepsClickable = false,
  onClickStep,
}: IProps) => {
  const handleClick = (index) => () => {
    if (onClickStep) onClickStep(index);
  };

  const renderTitle = ({ title, optional }: TStepTitle) => {
    return (
      <>
        {title}
        {optional && (
          <CaptionLabel variant="caption">{lang("optional")}</CaptionLabel>
        )}
      </>
    );
  };

  return (
    <Stepper activeStep={activeStep} alternativeLabel>
      {steps.map((step, index) => (
        <Step key={index}>
          {stepsClickable ? (
            <StepButton onClick={handleClick(index)} completed={step.complete}>
              {renderTitle(step)}
            </StepButton>
          ) : (
            <StepLabel>{renderTitle(step)}</StepLabel>
          )}
        </Step>
      ))}
    </Stepper>
  );
};

export default TabsStepper;
